import { StepCard, StepView } from '../components/view';
import { StepPreview } from '../components/preview/index';

export const Email = ({
  isOpen = false,
  step = {},
  onOpen = () => {},
  onClose = () => {},
  blueprint = {},
}) => {
  if (isOpen) {
    return <StepPreview step={step} onClose={onClose} blueprint={blueprint} />;
  }
  return <StepView blueprint={blueprint} step={step} onOpen={onOpen} />;
};

export const EmailView = (props) => {
  return (
    <StepCard {...props}>
      <Email {...props} />
    </StepCard>
  );
};
